import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface SitePage {
  slug: string;
  fragment: string | null;
}

@Injectable()
export class SiteNavService {
  private readonly pageSubject = new BehaviorSubject<SitePage>({ slug: 'index', fragment: null });
  readonly page$ = this.pageSubject.asObservable();

  readonly loginRequest$ = new Subject<string>();
  readonly signupRequest$ = new Subject<void>();

  get current(): SitePage { return this.pageSubject.value; }

  go(target: string | any[], fragment?: string | null) {
    const raw = Array.isArray(target) ? target.filter(x => x !== '/').join('/') : String(target || '');
    const slug = raw.replace(/^\/+/, '').replace(/\/+$/, '') || 'index';
    if (slug === 'create-account') {
      this.signupRequest$.next();
      return;
    }
    if (slug === 'login') {
      this.loginRequest$.next('patient');
      return;
    }
    this.pageSubject.next({ slug, fragment: fragment || null });
  }
}
